export class Microsoft365UserMailSelectedItemsOptions {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "items",
            "baseName": "items",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "folderName",
            "baseName": "folderName",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return Microsoft365UserMailSelectedItemsOptions.attributeTypeMap;
    }
    constructor() {
    }
}
